<template>
  <div class="mobile-container">
    <div class="pb-05">
      <v-alert
        dense
        text
        type="warning"
        icon="mdi-shield-alert"
        class="caption-regular pa-3 mb-2"
        rounded="0"
      >
        اطلاعات محل {{ place }} را با دقت وارد نمایید. (حداکثر 3 محل)
      </v-alert>
    </div>

    <v-form v-model="validate[type]">
      <v-expansion-panels v-model="accordion" multiple class="rounded-0">
        <v-expansion-panel
          v-for="(item, i) in filteredSR()"
          :key="i"
          class="mb-3 ev-0 rounded-0 place-accordion"
        >
          <v-expansion-panel-header
            >محل {{ place }}
            {{ filteredSR().length > 1 ? i + 1 : "" }}</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <keep-alive>
              <place-form
                :type="type"
                :place-index="i"
                :validate="validate"
                @delete="removePlace"
                :load-senders-and-recievers="item"
                :selected-city="selectedCity.city"
                @toggle-city-dialog="toggleCityDialog"
              ></place-form>
            </keep-alive>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>

    <div class="mb-4 mt-2">
      <v-btn
        @click="addPlace()"
        block
        elevation="0"
        class="logistic-color lighten rounded-0 py-5"
        ><v-icon left>mdi-plus</v-icon>افزودن محل {{ place }} بیشتر
      </v-btn>
    </div>

    <div v-if="filteredSR().length > 1" class="mb-2">
      <v-btn
        @click="reorder = true"
        block
        elevation="0"
        class="logistic-color lighten rounded-0 py-5"
        ><svg-icon name="arrow-up-down" left>mdi-plus</svg-icon>جابه جایی
      </v-btn>
    </div>

    <v-dialog
      v-model="reorder"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card rounded="0" color="#f5f5f5" class="h-screen">
        <v-card-title class="white py-0 px-3 border-b">
          <span class="d-inline-flex my-auto">
            <v-icon @click="reorder = false" class="my-auto mr-1 ml-6"
              >mdi-arrow-right</v-icon
            >
            <span class="d-inline-block my-4 high-emp subtitle1-regular"
              >جابه جایی محل {{ place }}</span
            >
          </span>
        </v-card-title>
        <reorder
          :list="filteredSR()"
          :type="type"
          :place="place"
          @close="closeReorder()"
        ></reorder>
      </v-card>
    </v-dialog>

    <city-select-list
      :visible="cityDialog"
      title=""
      :current-value="selectedCity"
      @handle-place-dialog="handleCityDialog"
    ></city-select-list>
  </div>
</template>

<script>
import CitySelectList from "../CitySelectList.vue";
import PlaceForm from "./components/PlaceForm.vue";
import Reorder from "./components/Reorder.vue";

export default {
  name: "Identity",
  components: { PlaceForm, CitySelectList, Reorder },
  props: {
    type: {
      type: String,
      require: true,
    },
    load: {
      type: Object,
      require: true,
    },
    permissions: {
      type: Array,
      require: true,
      default: [false, false, false, false],
    },
  },
  data() {
    return {
      cityDialog: false,
      reorder: false,
      selectedCity: {
        state: null,
        city: null,
      },
      validate: {
        sender: false,
        receiver: false,
      },
      accordion: [0],
      currentPlace: null,
    };
  },
  created() {
    this.initPlaceForm();
    this.$store.commit("get_drafts", this.type);
  },
  computed: {
    place() {
      const type = this.type;
      return type == "receiver" ? "تخلیه" : "بارگیری";
    },
  },
  watch: {
    "validate.sender"(val) {
      this.permissions.splice(0, 1, val);
    },
    "validate.receiver"(val) {
      this.permissions.splice(1, 1, val);
    },
  },
  methods: {
    initPlaceForm() {
      this.$set(this.load, "senders_and_recievers", [
        { is_sender: true, order_id: 10, type: 2 },
        { is_sender: false, order_id: 20, type: 2 },
      ]);
    },
    filteredSR() {
      let flag = this.type == "sender" ? true : false;
      return this.load.senders_and_recievers
        .filter((sr) => sr.is_sender == flag)
        .sort((a, b) => parseInt(a.order_id) - parseInt(b.order_id));
    },
    addPlace() {
      let counter = this.filteredSR().length;
      if (counter > 2) return;

      const maxOrderId = Math.max.apply(
        Math,
        this.filteredSR().map(function (sr) {
          return sr.order_id;
        })
      );

      let sr = this.load.senders_and_recievers;
      sr.push({
        is_sender: this.type == "sender" ? true : false,
        order_id: maxOrderId + 1,
      });
      this.accordion = [counter];
      this.$set(this.load, "senders_and_recievers", sr);
    },
    removePlace(oid) {
      const index = this.load.senders_and_recievers.findIndex(
        (sr) => sr.order_id == oid
      );

      this.$delete(this.load.senders_and_recievers, index);
      this.accordion = [this.filteredSR().length - 1];
    },
    handleCityDialog(op, data) {
      if (op === "close") {
        this.cityDialog = false;
        if (!data) {
          this.resetLocation();
          return;
        }
        this.selectedCity = data;
        this.fillPlace(data.city, data.state);
      }
    },
    fillPlace(city = null, state = null) {
      let filteredSR = this.filteredSR();

      filteredSR[this.currentPlace].city = city;
      filteredSR[this.currentPlace].ostan = state;
    },
    resetLocation() {
      this.selectedCity = {
        state: null,
        city: null,
      };
      this.fillPlace();
    },
    toggleCityDialog(i) {
      this.currentPlace = i;
      this.cityDialog = !this.cityDialog;
    },
    closeReorder() {
      this.reorder = false;
    },
  },
};
</script>

<style scoped>
@media (min-width: 960px) {
  .px-md-30 {
    padding: 0 25vw;
  }
}
.place-accordion >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.border-b {
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25);
}
</style>
